import * as React from 'react';

export interface WarningModalComponentProps {
    itemId: string
    itemContent: string
}

const WarningModalComponent = ({ itemId, itemContent }: WarningModalComponentProps) => {

    return (
        <div className="modal fade" id={itemId} tabIndex={-1} >
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-header">
                        <h3 className="modal-title">Warning</h3>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body" dangerouslySetInnerHTML={{ __html: itemContent }}>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-primary" data-bs-dismiss="modal">Okay</button>
                    </div>
                </div>
            </div>
        </div>
    )

}

export default WarningModalComponent;